/* eslint-disable */
import { callStatic, UgcCounts } from 'services/api-service'

/**
 * Counts for each ugc type, formally itemjs
 *
 * @method
 * @name ApiService#ugcCounts
 * @param {string} sku -
 */
function ugcCounts(parameters: { sku: string }): Promise<UgcCounts> {
  return callStatic<UgcCounts>('/sitedata/{siteKey}/{sku}/d/ugc/counts/{locale}', parameters, [
    'sku'
  ])
}

export default { ugcCounts }
